<template>
  <div>
    <el-form label-position="top" :rules="rules" ref="ruleForm" label-width="80px" :model="rulesForm">
      <vue-dividing-line title="基本設定"></vue-dividing-line>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="題目編號" prop="question_no">
            <el-input v-model="rulesForm.question_no" placeholder="請輸入題目編號"></el-input> </el-form-item
        ></el-col>
         <el-col :span="8">
          <el-form-item label="語言" prop="lang">
            <el-select v-model="rulesForm.lang" placeholder="請選擇語言">
              <el-option v-for="(item, index) in lang" :key="index"
                :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <!-- <el-col :span="8">
          <el-form-item label="語言" prop="lang">
            <el-select v-model="rulesForm.lang" placeholder="請選擇語言">
              <el-option v-for="(item, index) in lang" :key="index"
                :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col :span="8">
          <el-form-item label="分數" prop="score"> 
            <el-input-number v-model="rulesForm.score" controls-position="right" :min="1" placeholder="請輸入分數"></el-input-number>
          </el-form-item
        ></el-col>
        <!-- <el-col :span="8">
          <el-form-item label="難易程度" prop="level">
            <el-select v-model="rulesForm.level" placeholder="請選擇難度">
              <el-option v-for="(item, idx) in level" :key="idx"
                :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item
        ></el-col> -->
      </el-row>
      <vue-dividing-line title="問題"></vue-dividing-line>
      <el-form-item label="問題" prop="title">
        <Tinymce v-model="rulesForm.title" ref="Tinymce"></Tinymce>
      </el-form-item>
      <vue-dividing-line title="拖拽選項及答案"></vue-dividing-line>

      <el-form-item label="類型" v-if="!rulesForm.id">
        <el-radio-group v-model="createType" size="small">
          <el-radio label="1" >填空</el-radio>
          <el-radio label="2" >分類</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- 填空 -->
      <div v-if="createType == '1'">
        <div class="required aa">內容</div>

        <div>
          <i class="el-icon-warning-outline"></i>
          每個填空格只能容納10個數位。
        </div>
        <div>
          <i class="el-icon-warning-outline"></i>
          將需要填入答案的地方以英文符號@#括住。
        </div>

        <el-row :gutter="20">
          <el-col :span="24" v-for="(item, index) in question" :key="index">
            <div class="required">行 {{ letter[index] }} *</div>
            <div class="block">
              <div class="label">文字 <span class="required">*</span> </div>
              <div class="text-area">
                <el-input v-model="item.content"  @input="changeChoice(index)" placeholder="請輸入文字">
                  <template slot="append">
                    <el-button
                      type="info"
                      class="browse-button"
                      @click="uploadFormData(item)"
                    >
                    瀏覽</el-button
                    >
                  </template>
                </el-input>
              </div>
              <div v-if="!item.content && rules_switch" class="prop-tips">請輸入文字</div>
            </div>
          </el-col>
          <el-col :span="24">
          </el-col>
        </el-row>

        <div class="required">幹擾選項</div>
        <div>
          <i class="el-icon-warning-outline"></i>
          每個幹擾選項只能容納10個數位。
        </div>
        <el-row :gutter="20">
          <el-col :span="6" v-for="(item, index) in choice" :key="index">
            <div class="required">幹擾選項 {{index+1}}</div>
            <el-form-item label="數字">
              <el-input v-model="item.content"  placeholder="請輸入數字">
                <template slot="append">
                  <el-button
                    type="info"
                    class="browse-button"
                    @click="uploadFormData(item)"
                  >
                  瀏覽</el-button
                  >
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
          </el-col>
        </el-row>
      </div>
      <!-- 选项 -->
      <div class="" v-else>
        <div>選項欄</div>
        <el-row :gutter="20">
          
          <el-col :span="12"  v-for="(item, index) in right" :key="index">
            <div>選項 {{ index + 1 }}</div>
            <el-row>
              <el-col :span="4">顯示方式 </el-col>
              <el-col :span="9">
                <el-radio-group v-model="item.type">
                  <el-radio label="text">文字</el-radio>
                  <el-radio label="image">圖片</el-radio>
                </el-radio-group></el-col
              >
            </el-row>
            <div v-if="item.type == 'text'" class="block">
              <div class="label">文字 </div>
              <el-input v-model="item.textValue"  placeholder="請輸入文字"></el-input>
              <div v-if="!item.textValue && rules_switch" class="prop-tips">請輸入文字</div>
            </div>
            <div v-else class="block">
              <div class="label">圖片 </div>
              <upload :placeholder="rulesForm.img_url || '請選擇問題圖片'" @childByValue="url => onUploadSuccessChoice(url, item)"></upload>
              <div class="img-box" v-if="item.imgValue">
                <div class="close" @click="item.imgValue = ''"></div>
                <img :src="item.imgValue" />
              </div>
              <div v-else-if="rules_switch" class="prop-tips">請選擇圖片</div>
            </div>
            <div class="block">
              <div class="label">配對分類選項</div>
              <el-select v-model="item.tips" placeholder="請選擇" multiple>
                <el-option
                  v-for="(its, idx) in left" :key="idx"
                  :label="`分類${its.tips * 1 + 1}`" :value="its.tips">
                </el-option>
              </el-select>
            </div>
          </el-col>
        </el-row>
        <br/>
        <div>分類欄</div>
        <el-row :gutter="20">
          
          <el-col :span="12"  v-for="(item, index) in left" :key="index">
            <div class="required">分類 {{ index + 1 }}</div>
            <div class="block">
              <div class="label">文字 <span class="required">*</span> </div>
              <el-input v-model="item.value"  placeholder="請輸入文字"></el-input>
              <div v-if="!item.value && rules_switch" class="prop-tips">請輸入文字</div>
            </div>
          </el-col>
        </el-row>
      </div>
      <vue-dividing-line title="解答思路"></vue-dividing-line>
      <Tinymce v-model="rulesForm.explanation"></Tinymce>
      <div class="sibmit-button">
        <div class="left">
          <el-button type="info" @click="onSubmit">提交</el-button>
          <el-button type="success" @click="onBack">取消</el-button>
        </div>
        <el-button type="info" @click="preview">預覽題目</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import upload from "@/components/upload";
import Tinymce from "@/components/Tinymce";
import { symbol } from '../plugins/directive'
import rules from "../plugins/validator";
import { file } from "@/api/files";

let pLeft = 'PARENTHESISLEFT', pRight = 'PARENTHESISRIGHT'

export default {
  directives: {
    symbol
  },
  props: ['formLabelAlign'],
  components: { Tinymce, upload },
  data() {
    let letter = new Array(26).fill().map((its, idx) => its = String.fromCharCode(65 + idx))

    return {
      letter,

      // 语言
      lang: [
        {label: '中文', value: 0},
        {label: '英文', value: 1},
      ],
      // 难易程度
      level: [
        {label: '※', value: 1},
        {label: '※※', value: 2},
        {label: '※※※', value: 3},
        {label: '※※※※', value: 4},
        {label: '※※※※※', value: 5},
      ],
      rulesForm: {},
      // rulesForm: {
      //   lang: "",
      //   title: "",
      //   img_url: '',
      //   type: 5,
      //   score: 1,
      //   level: 1,
      //   explanation: '',
      //   answers: [],
      //   choices: [],
      //   content: '',
      // },
      rules,
      units: [],
      createType: '1',
      // 填空
      choice: [
        {content: ''},
        {content: ''},
        {content: ''},
        {content: ''}
      ],
      question: [
        {content: '', arr: []},
        {content: '', arr: []},
        {content: '', arr: []},
        {content: '', arr: []}
      ],

      // 选项
      left: [
        {value: '', tips: '0', rightTips: []},
        {value: '', tips: '1', rightTips: []},
      ],
      right: [
        {textValue: '', imgValue: '', tips: [], type: 'text'}, {textValue: '', imgValue: '', tips: [], type: 'text'},
        {textValue: '', imgValue: '', tips: [], type: 'text'}, {textValue: '', imgValue: '', tips: [], type: 'text'},
        {textValue: '', imgValue: '', tips: [], type: 'text'}, {textValue: '', imgValue: '', tips: [], type: 'text'},
        {textValue: '', imgValue: '', tips: [], type: 'text'}, {textValue: '', imgValue: '', tips: [], type: 'text'},
      ],

      rules_switch: false
    };
  },
  methods: {
    uploadFormData(item) {
      // console.log(item)
      let file = document.createElement('input')
      file.type = 'file'
      // image/jpeg, image/png
      file.setAttribute('accept', 'image/*')
      file.onchange = () => {
        let files = file.files[0]
        // console.log(files)

        this.uploadImage(item, files)
        // 重置数据
        file.value = ''
      }

      file.click()
    },
    uploadImage(item, files) {
      const formData = new FormData();
      formData.append("file", files);
      file('/files', formData)
        .then((v) => {
          let url = v.data.replace(/(?:https?:\/\/)?([a-zA-Z0-9-]+\.[a-zA-Z0-9-]+\.[a-zA-Z]{2,})/g, '')
          item.content += `<img src="${url}" />`
          this.$message({
            type: "success",
            message: "上傳成功!",
          });
        })
        .finally(() => {
          
        });
    },
    preview() {
      let {form, type} = this.handleFromData()
      form.type = type
      // console.log(form)
      this.$emit('preview', form)
    },
    changeChoice(idx) {
      let item = this.question[idx]
      , content = item.content,
      // regex1 = /(\\left\()*[^(\s]*\(((\\left\(|\\right\)|\S| )+?)\)/g, 
      regex1 = /@(.*?)#/g,
      // regex1 = /\([^()]*\)|\\left\([^\\()]*\\right\)/g,
      res, subscript = 0, arr = []
      // console.log(content)
      content = content.replaceAll('\\left(', pLeft).replaceAll('\\right)', pRight)

      // console.clear()
      // let matches = content.match(regex1);
      // if (matches) {
      //   console.log(matches)
      //   res = matches.filter(function(match) {
      //       return !match.includes('\\left(') && !match.includes('\\right)');
      //   });
      // }
      res = content.match(regex1)
      // console.clear()
      // console.log(content)
      // console.log(regex1)
      // console.log(res)
      if(res) {
        // 默认字符结构
        for(let i = 0; i < res.length; i++) {
          let s = content.substring(0, content.indexOf(res[i]))
          let its = res[i].replaceAll(pLeft, '\\left(').replaceAll(pRight, '\\right)')
          s = s.replaceAll(pLeft, '\\left(').replaceAll(pRight, '\\right)')
          
          arr.push(...[
            { text: s, answerArea: false, type: 'default' }, 
            { text: its, answerArea: true, type: 'default'}, 
          ])
          subscript = (s + its).length
          content = content.substring(subscript)
        }
      }
      // content = content.replaceAll(pLeft, '\\left(').replaceAll(pRight, '\\right)')
      // console.log(arr)
      arr.push({ text: content, answerArea: false, type: 'default' })
      item.arr = arr
    },
    removeChoice(idx, data) {
      this[data].splice(idx, 1);
    },
    addChoiceOption(data) {
      switch(data) {
        case 'choice': 
          this.choice.push({content: ''})
          ; break
        case 'question':
          this.question.push({content: '', arr: []})
          ; break
      }
    },
    addChoice() {
      this.right.push({ value: '', tips: '1'})
    },
    remove(idx) {
      this.right.splice(idx, 1);
    },
    onUploadSuccess(url) {
      this.rulesForm.img_url = url;
    },
    onUploadSuccessChoice(url, item) {
      item.imgValue = url
    },
    // 校验數据填写情况
    validator_data() {
      let {left, right, createType} = this

      if(createType == '2') {
        this.rules_switch = false
        left.some(item => item.value == '') && (this.rules_switch = true)
        let hege = right.filter(item => {
          let value
          if(item.type == 'text') value = item.textValue
          else  value = item.imgValue
          return value.trim() != '' ? item : false
        })
        if(hege.length < 2) {
          this.$message.error('選項最少選择2個')
          return false
        }
      }
      this.$refs['ruleForm'].validate(() => {})
      return this.rules_switch
    },
    handleFromData() {
      let form = JSON.parse(JSON.stringify(this.rulesForm)),
      { choice, question, createType } = this, newArr = [], type = 5
      form.answers = []
      form.choices = []

      // 处理數据
      if(createType == '1') {
        // console.log(question)
        question.filter(item => {
          let arr = []
          item.arr.filter(its => {
            if(its.answerArea) {
              if(its.type == 'default') {
                let text = its.text.substring(1, its.text.length - 1)
                text = text.replaceAll('\\left(', '(').replaceAll('\\right)', ')')
                newArr.push({content: text})
                arr.push(text)
              } else if(its.type == 'mixedNumber' || its.type == 'decimals') {
                let val = its.map.filter(a => a.fill).map(a => a.val).flat()
                val.filter(a => newArr.push({content: a.replaceAll('\\left(', '(').replaceAll('\\right)', ')')}))
                arr.push(...val)
              }

            }
          })
          form.answers.push({value: JSON.stringify(arr)})
          form.choices.push({value: item.content.replace(/@(.*?)#/g, '@#')})
        })
        form.answers.push({value: choice.map(its => its.content).join(',')})
  
        form.content = JSON.stringify({
          choice: [...newArr, ...choice], question
        })
      } else {
        let { right, left } = this, tempArr = []
        left.forEach((item) => item.rightTips = [])
        // 处理數据
        right.filter((its, index) => {
          its.tips.filter(item => {
            left[item].rightTips.push(index)
          })

          // 追加 choices 數据
          if(its.type == 'text')
            tempArr.push({type: 'text', value: its.textValue})
          else 
            tempArr.push({type: 'image', value: its.imgValue})
        })
        // console.log(tempArr)
        form.choices[1] = {value: JSON.stringify(tempArr)}

        // 重置
        tempArr = []

        // console.log(left)
        left.filter(its => {
          form.answers.push({value: its.rightTips.join(',')})

          // 追加 choices 數据
          tempArr.push({type: 'text', value: its.value})
        })
        // console.log(tempArr)
        form.choices[0] = {value: JSON.stringify(tempArr)}

        let ligatureList = []
        right.filter((its, idx) => {
          ligatureList.push({
            left: left[idx] ? {...left[idx]} : null,
            right: {...its}
          })
        })
        
        form.content = JSON.stringify({
          ligatureList
        })
        type = 9
      }
      return {form, type};
    },
    // 提交
    onSubmit() {
      if(this.validator_data()) return ;
      // console.log('onSubmit')
      let {form, type} = this.handleFromData()

      // console.log(form, type)
      // type, type_display
      this.$emit('save', form, type, 5)
    },
    // 返回
    onBack() {
      this.$emit('cancel', this.rulesForm)
    },
  },
  created() {
    this.rulesForm = {...this.formLabelAlign}
  },
  mounted() {
    if(this.rulesForm.id) {
      if(this.rulesForm.type == 5) {
        let {choice, question} = JSON.parse(this.rulesForm.content)
        // console.log(choice, question)
        this.question = question
        this.choice = choice.slice(-4)
        
        for(let i = 0; i < question.length; i++ ) {
          this.changeChoice(i)
        }
      } else {
        this.createType = '2'
        let {ligatureList} = JSON.parse(this.rulesForm.content)
      
        // console.log(ligatureList)
        this.left = []
        this.right = []
        ligatureList.filter((its, ) => {
          if(its.left) {
            its.left.rightTips = []
            this.left.push(its.left)
          }
          this.right.push(its.right)
        })
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.newly-added, .remove-choice {
  display: block;
  width: 120px;
  padding: 10px 0;
  text-align: center;
  font-size: 20px;
  color: #333;
  background-color: #ffb842;
  border-radius: 10px;
  cursor: pointer;
  margin-bottom: 10px;
}
.remove-choice {
  background-color: #EA4C4E;
  color: #fff;
}

.choice {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.func-choice {
  width: 100%;
  display: flex;

  * {
    margin-right: 10px;
  }
}
.block {
  margin: 10px 0;

  .label {
    font-size: 14px;
    color: rgba(142, 142, 142, 1);
  }
}
</style>